import { useQuery } from '@tanstack/react-query';
import { getAppsheetDealerContext, getAppSheetStatusChangeMetrics, getAppSheetStatusChanges } from './appsheetApi';

export const createAppsheetHooks = () => {
    const useAppsheetDealerContext = (bac, options = {}) =>
        useQuery({
            queryKey: ['appsheetDealerContext', { bac, includeTrade: Boolean(options.includeTrade) }],
            queryFn: () => getAppsheetDealerContext({ bac, includeTrade: options.includeTrade }),
            enabled: Boolean(bac) && (options.enabled ?? true),
            staleTime: options.staleTime ?? 30 * 1000,
        });

    const useAppSheetStatusChangeMetrics = (options = {}) =>
        useQuery({
            queryKey: ['appsheetStatusChangeMetrics', { programName: options.programName || null }],
            queryFn: () => getAppSheetStatusChangeMetrics(options),
            refetchInterval: options.refetchInterval ?? 60 * 1000,
        });

    const useAppSheetStatusChanges = (options = {}) =>
        useQuery({
            queryKey: ['appsheetStatusChanges', options],
            queryFn: () => getAppSheetStatusChanges(options),
            staleTime: 30 * 1000,
            keepPreviousData: true,
        });

    return {
        useAppsheetDealerContext,
        useAppSheetStatusChangeMetrics,
        useAppSheetStatusChanges,
    };
};
